import { BUNDLE_INVENTORY_GET_SUCCESS } from '../actionTypes/BundleInventoryActionTypes';

function InventoryReducer(state = [], action) {
    switch (action.type) {
        case BUNDLE_INVENTORY_GET_SUCCESS:
            return [].concat(action.inventory);
        default:
            return state;
    }
}

InventoryReducer.reducerName = 'bundleInventory';
export default InventoryReducer;
